import { ActionListItem } from './models/interaction-editor.model';

export const ACTION_LIST_ITEMS: ActionListItem[] = [
  {
    value: 'Spraak',
    type: 'speak',
    icon: 'volume_up',
  },
  {
    value: 'Audio',
    type: 'audio',
    icon: 'music_note',
    requiredPermission: 'media:read',
  },
  {
    value: 'Afbeelding tonen',
    type: 'image',
    icon: 'image',
    requiredPermission: 'media:read',
  },
  {
    value: 'SMS notificatie',
    type: 'notification-sms',
    icon: 'sms',
    requiredPermission: 'contact:read',
  },
  {
    value: 'Ga naar interactie',
    type: 'goto-interaction',
    icon: 'record_voice_over',
  },
  {
    value: 'Ga naar vraag',
    type: 'goto-question',
    icon: 'live_help',
  },
  {
    value: 'Stop interactie',
    type: 'stop',
    icon: 'remove_circle',
  },
] as const;
